// 夜航灯开关
export enum NightLightsStateEnum {
  CLOSE = 0, // 0-关闭
  OPEN = 1, // 1-打开
}

// 限远开关
export enum DistanceLimitStatusEnum {
  UNSET = 0, // 0-未设置
  SET = 1, // 1-已设置
}

export interface DistanceLimitStatus {
  state?: DistanceLimitStatusEnum;
  distance_limit?: number; // 限远
  is_near_distance_limit?: boolean
}

// 避障
export enum ObstacleAvoidanceStatusEnum {
  CLOSE = 0, // 0-关闭
  OPEN = 1, // 1-开启
}

export interface ObstacleAvoidance {
  horizon?: ObstacleAvoidanceStatusEnum;// 水平避障开关
  upside?: ObstacleAvoidanceStatusEnum;// 上行方向避障开关
  downside?: ObstacleAvoidanceStatusEnum;// 下行方向避障开关
}

// 设备管理设置key
export enum DeviceSettingKeyEnum {
  NIGHT_LIGHTS_MODE_SET = 'night_lights_state', // 夜航灯开关
  HEIGHT_LIMIT_SET = 'height_limit', // 限高设置
  DISTANCE_LIMIT_SET = 'distance_limit_status', // 限远开关
  OBSTACLE_AVOIDANCE_HORIZON = 'obstacle_avoidance_horizon', // 水平避障状态
  OBSTACLE_AVOIDANCE_UPSIDE = 'obstacle_avoidance_upside', // 上视避障状态
  OBSTACLE_AVOIDANCE_DOWNSIDE = 'obstacle_avoidance_downside', // 下视避障状态
}

export type DeviceSettingType = Record<DeviceSettingKeyEnum, any>

export const initDeviceSetting = {
  [DeviceSettingKeyEnum.NIGHT_LIGHTS_MODE_SET]:
  {
    label: 'Aircraft Night Navigation Lights', // 飞行器夜航灯
    value: '',
    trueValue: NightLightsStateEnum.CLOSE,
    editable: false,
    popConfirm: {
      visible: false,
      loading: false,
      // content: 'To ensure flight operation safety, it is recommended to turn on the night navigation lights', // 为保证飞行器的作业安全，建议打开夜航灯
      label: 'Aircraft Night Navigation Lights', // 飞行器夜航灯
    },
    settingKey: DeviceSettingKeyEnum.NIGHT_LIGHTS_MODE_SET,
  },
  [DeviceSettingKeyEnum.HEIGHT_LIMIT_SET]:
  {
    label: 'Altitude Limit', // 限高
    value: '',
    trueValue: 120,
    editable: false,
    popConfirm: {
      visible: false,
      loading: false,
      // content: 'Altitude limit: 20 - 1500m', // 限高：20 - 1500m
      // info: 'Changing the altitude limit will affect all current airfield operations. Please confirm before making changes.', // 修改限高会影响当前机场的所有作业任务，建议确认作业情况后再进行修改
      label: 'Altitude Limit', // 限高
    },
    settingKey: DeviceSettingKeyEnum.HEIGHT_LIMIT_SET,
  },
  [DeviceSettingKeyEnum.DISTANCE_LIMIT_SET]:
  {
    label: 'Distance Limit', // 限远
    value: '',
    trueValue: DistanceLimitStatusEnum.UNSET,
    // info: 'Distance limit (15 - 8000m) constrains the aircraft's maximum operating distance from the airfield', // 限远（15 - 8000m）是约束飞行器相对机场的最大作业距离
    editable: false,
    popConfirm: {
      visible: false,
      loading: false,
      // content: 'Distance limit (15 - 8000m) constrains the aircraft's maximum operating distance from the airfield', // 限远 (15- 8000m) 是约束飞行器相对机场的最大作业距离
      // info: 'Changing the distance limit will affect all current airfield operations. Please confirm before making changes.', // 修改限远会影响当前机场的所有作业任务，建议确认作业情况后再进行修改
      label: 'Distance Limit', // 限远
    },
    settingKey: DeviceSettingKeyEnum.DISTANCE_LIMIT_SET,
  },
  [DeviceSettingKeyEnum.OBSTACLE_AVOIDANCE_HORIZON]:
  {
    label: 'Horizontal Obstacle Avoidance', // 水平避障
    value: '',
    trueValue: ObstacleAvoidanceStatusEnum.CLOSE,
    // info: 'Displays the aircraft obstacle avoidance status. Quickly turn on/off avoidance here. For more settings, use the device maintenance page.', // 飞行器的避障工作状态显示，可以快速开启/关闭飞行器避障，如需进一步设置请在设备运维页面设置
    editable: false,
    popConfirm: {
      visible: false,
      loading: false,
      // content: 'Obstacle avoidance is a basic safety feature. It is recommended to keep it enabled.', // 飞行器避障是保障飞行作业安全的基础功能，建议保持飞行器避障开启
      label: 'Horizontal Obstacle Avoidance', // 水平避障
    },
    settingKey: DeviceSettingKeyEnum.OBSTACLE_AVOIDANCE_HORIZON,
  },
  [DeviceSettingKeyEnum.OBSTACLE_AVOIDANCE_UPSIDE]:
  {
    label: 'Upward Obstacle Avoidance', // 上视避障
    value: '',
    trueValue: ObstacleAvoidanceStatusEnum.CLOSE,
    // info: 'Displays the aircraft obstacle avoidance status. Quickly turn on/off avoidance here. For more settings, use the device maintenance page.', // 飞行器的避障工作状态显示，可以快速开启/关闭飞行器避障，如需进一步设置请在设备运维页面设置
    editable: false,
    popConfirm: {
      visible: false,
      loading: false,
      // content: 'Obstacle avoidance is a basic safety feature. It is recommended to keep it enabled.', // 飞行器避障是保障飞行作业安全的基础功能，建议保持飞行器避障开启
      label: 'Upward Obstacle Avoidance', // 上视避障
    },
    settingKey: DeviceSettingKeyEnum.OBSTACLE_AVOIDANCE_UPSIDE,
  },
  [DeviceSettingKeyEnum.OBSTACLE_AVOIDANCE_DOWNSIDE]:
  {
    label: 'Downward Obstacle Avoidance', // 下视避障
    value: '',
    trueValue: ObstacleAvoidanceStatusEnum.CLOSE,
    // info: 'Displays the aircraft obstacle avoidance status. Quickly turn on/off avoidance here. For more settings, use the device maintenance page.', // 飞行器的避障工作状态显示，可以快速开启/关闭飞行器避障，如需进一步设置请在设备运维页面设置
    editable: false,
    popConfirm: {
      visible: false,
      loading: false,
      // content: 'Obstacle avoidance is a basic safety feature. It is recommended to keep it enabled.', // 飞行器避障是保障飞行作业安全的基础功能，建议保持飞行器避障开启
      label: 'Downward Obstacle Avoidance', // 下视避障
    },
    settingKey: DeviceSettingKeyEnum.OBSTACLE_AVOIDANCE_DOWNSIDE,
  },
} as DeviceSettingType

export const initDeviceSettingFormModel = {
  nightLightsState: false, // 夜航灯开关
  heightLimit: 20, // 限高设置
  distanceLimitStatus: { state: false, distanceLimit: 15 }, // 限远开关
  obstacleAvoidanceHorizon: false, // 飞行器避障-水平开关设置
  obstacleAvoidanceUpside: false, // 飞行器避障-上视开关设置
  obstacleAvoidanceDownside: false, // 飞行器避障-下视开关设置
}

export type DeviceSettingFormModel = typeof initDeviceSettingFormModel
